import React from 'react';
import {
  Box,
  FormControlLabel,
  MenuItem,
  Radio,
  Typography,
} from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';

interface ExistingPaymentMethodsForm {
  isNewPaymentMethod: boolean;
  existingPaymentMethodToken: string;
}

interface Props {
  category: string;
  paymentMethods: any[];
}

const ExistingPaymentMethods = ({ category, paymentMethods }: Props) => {
  const { values, setFieldValue } =
    useFormikContext<ExistingPaymentMethodsForm>();

  return (
    <Box sx={{ mb: 2 }}>
      <FormControlLabel
        control={
          <Radio
            checked={!values.isNewPaymentMethod}
            onChange={(e) =>
              setFieldValue('isNewPaymentMethod', !e.target.checked)
            }
            value="existingCard"
          />
        }
        label={
          <Typography variant="subtitle1" fontWeight="bold">
            Existing Credit Cards
          </Typography>
        }
        labelPlacement="end"
      />
      <Box
        sx={{
          opacity: !values.isNewPaymentMethod ? 1 : 0.4,
          pointerEvents: !values.isNewPaymentMethod ? 'auto' : 'none',
          pt: 2,
        }}
      >
        {paymentMethods && (
          <Field
            component={TextField}
            select
            size="small"
            id="existingPaymentMethodToken"
            name="existingPaymentMethodToken"
            labelId="existing-card-label"
            label="Select Card"
          >
            {paymentMethods.map((card) => (
              <MenuItem key={card._id} value={card._id}>
                {`${card.cardType} ending in ${card.last4}`}
              </MenuItem>
            ))}
          </Field>
        )}
      </Box>
    </Box>
  );
};

export default ExistingPaymentMethods;
